import { FC, useRef } from 'react';
import { useParams } from 'react-router';

import { Button } from 'devextreme-react/button';
import DataGrid, {
  Column,
  ColumnChooser,
  FilterPanel,
  FilterRow,
  GroupPanel,
  HeaderFilter,
  Pager,
  Paging,
  StateStoring,
} from 'devextreme-react/data-grid';
import 'devextreme-react/text-area';

import { AppCard, AppLayoutTop } from 'components/appComponents';
import ClaimsProvider from 'components/claimsBlock';
import { useModal } from 'context/ModalProvider/useModal';

import { useGetContractorDeliveryPriceListQuery } from '../api/services';
import {
  CreateContractorDeliveryPriceModal,
  DeleteContractorDeliveryPriceModal,
  EditContractorDeliveryPriceModal,
} from './modals';

export const ContractorDeliveryPriceScreen: FC = () => {
  let { id } = useParams<{ id: string }>();
  const { showModal } = useModal();

  const refGrid = useRef<DataGrid | null>(null);

  const { data, refetch } = useGetContractorDeliveryPriceListQuery({
    id,
  });

  const showModalCreate = () => {
    showModal(<CreateContractorDeliveryPriceModal contractorId={id} onRefresh={refetch} />);
  };

  const showModalDelete = (id: number) => {
    showModal(<DeleteContractorDeliveryPriceModal id={id} onRefresh={refetch} />);
  };

  const showModalEdit = (rowId: number) => {
    showModal(<EditContractorDeliveryPriceModal contractorId={id} onRefresh={refetch} id={rowId} />);
  };

  return (
    <div>
      <AppLayoutTop title=" ">
        <ClaimsProvider claimsBlock={['CanChangeDeliveryPrice']}>
          <Button width={120} text="Создать" type="default" onClick={showModalCreate} />
        </ClaimsProvider>
      </AppLayoutTop>

      <AppCard>
        <DataGrid
          dataSource={data}
          showBorders={false}
          loadPanel={{
            enabled: true,
            text: 'Загрузка',
          }}
          ref={refGrid}
          remoteOperations={true}
          allowColumnResizing
          columnResizingMode="nextColumn"
          columnMinWidth={50}
          allowColumnReordering
        >
          <StateStoring enabled={true} type="localStorage" storageKey="contractorLegalDeliveryPrice" />
          <FilterRow visible={true} />
          <FilterPanel visible={true} />
          <HeaderFilter visible />
          <GroupPanel visible={true} />
          <ColumnChooser enabled={true} />

          <Column dataField="factoryName" caption="Площадка" />
          <Column dataField="objectName" caption="Объект" />
          <Column dataField="dateBegin" caption="Дата начала" dataType="date" />
          <Column dataField="dateEnd" caption="Дата окончания" dataType="date" />
          <Column dataField="maxQuantity" caption="Объем" />
          <Column dataField="price" caption="Цена" />

          <Column
            dataField=""
            caption=""
            width={150}
            cellRender={(data) => (
              <ClaimsProvider claimsBlock={['CanChangeDeliveryPrice']}>
                <div>
                  <Button icon="edit" type="default" stylingMode="text" onClick={() => showModalEdit(data.data.id)} />
                  <Button
                    icon="trash"
                    type="default"
                    stylingMode="text"
                    onClick={() => showModalDelete(data.data.id)}
                  />
                </div>
              </ClaimsProvider>
            )}
          />

          <Paging defaultPageSize={15} />
          <Pager showPageSizeSelector={true} allowedPageSizes={[15, 30, 50, 100]} />
        </DataGrid>
      </AppCard>
    </div>
  );
};
